import { AppBar, Box, Toolbar } from '@mui/material';
import React from 'react';
import { AppTitle } from '../app-title/app-title.component';
import { Navigation } from '../navigation/navigation.component';

export function Header() {
    return (
        <Box sx={{ height: 55 }}>
            <AppBar color="default" elevation={0}>
                <Toolbar>
                    <AppTitle />
                    <Navigation />
                </Toolbar>
            </AppBar>
        </Box>
    );
}
